import React from "react";
import { SearchProduct } from "./SearchProduct";

const MainContainer = () => {

     return (
        <SearchProduct />
     )
}

export default MainContainer;